import * as React from 'react';
import Text from '../../shared/Text';
import FormValidationMessage from './form-validation-message';
import { LOGIN_INDEX } from '../constants/routes';
import { useFetchIdentityProviders, useOnSubmitSso, useSetSsoData, useSsoData } from './providers/sso/hooks';
import { useAuthData } from './providers/auth/hooks';
import { Button, FormControl, InputLabel, Link, MenuItem, Select, Typography } from '@mui/material';
import { FormFieldWrapper, FormSubmitWrapper, FormWrapper } from './shared-form-components';

const Sso: React.FC = () => {
  const fetchIdentityProviders = useFetchIdentityProviders();
  const onSubmitSso = useOnSubmitSso();
  const setSsoData = useSetSsoData();

  const { identityProviders, ssoIdentityProviderUid: selectedProviderUid, ssoError: error } = useSsoData();
  const { regKey, username } = useAuthData();

  React.useEffect(() => {
    fetchIdentityProviders({ registrationKey: regKey, username });
  }, []);

  React.useEffect(() => {
    if (identityProviders.length === 1) {
      onSubmitSso(identityProviders[0].ssoIdentityProviderUid);
    }
  }, [identityProviders]);

  // build menu items and find current selected index
  const idpMenuItems = identityProviders.map((idp) => {
    const currentUid = idp.ssoIdentityProviderUid;
    return {
      payload: currentUid,
      text: idp.displayName,
    };
  });

  const submitHandler = (e: React.FormEvent<any>) => {
    e.preventDefault();
    onSubmitSso(selectedProviderUid);
  };

  const changeProviderHandler: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    setSsoData((current) => ({
      ...current,
      ssoIdentityProviderUid: event.target.value,
    }));
  };

  return (
    <FormWrapper>
      <form name="ssoFrm" noValidate>
        <FormValidationMessage message={error} />

        <FormFieldWrapper>
          <Typography>{Text.get('sso_title')}</Typography>
        </FormFieldWrapper>

        <FormFieldWrapper>
          <FormControl fullWidth>
            <InputLabel id="provider-label">Select provider</InputLabel>
            <Select
              data-test="sso-form-provider-dropdown"
              fullWidth
              label="Select provider"
              labelId="provider-label"
              onChange={changeProviderHandler}
              value={selectedProviderUid || ''}
            >
              {idpMenuItems.map((item) => (
                <MenuItem key={item.payload} value={item.payload}>
                  {item.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </FormFieldWrapper>

        <FormSubmitWrapper>
          <Button
            data-test="submit"
            disabled={selectedProviderUid == null}
            name="submit"
            onClick={submitHandler}
            type="submit"
            variant="contained"
          >
            {Text.get('_button_continue')}
          </Button>
        </FormSubmitWrapper>

        <FormFieldWrapper>
          <Link href={`#${LOGIN_INDEX}`}>{Text.get('sso_signin_different_account')}</Link>
        </FormFieldWrapper>
      </form>
    </FormWrapper>
  );
};

export default Sso;
